/**
 * PLP cover scrub (Eurus-style): X-position over the product image maps to
 * up to 3 images + top progress segments. Image area only (not the whole tile).
 * Brief opacity dissolve; resets to first image when leaving the cover.
 *
 * Listens on the card (not .media) because Dawn’s title stretch-link ::after
 * sits above the image and would otherwise steal mousemove.
 *
 * Re-inits after facet AJAX: ProductGridContainer is replaced wholesale, so
 * observers must watch that host (not a one-shot #product-grid node).
 */
(function () {
  var DESKTOP = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var reinitTimer = null;

  function applyScrubIndex(root, index) {
    var imgs = root._riScrubImgs;
    var segs = root._riScrubSegs;
    var n = imgs.length;
    root._riScrubIndex = index;
    root._riScrubPending = null;
    for (var i = 0; i < n; i += 1) {
      imgs[i].classList.toggle('is-active', i === index);
    }
    for (var s = 0; s < segs.length; s += 1) {
      segs[s].classList.toggle('is-active', s === index);
    }
  }

  function ensureScrubSrc(img) {
    if (!img) return;
    var src = img.getAttribute('data-ri-scrub-src');
    if (!src) return;
    var current = img.getAttribute('src') || '';
    if (!current || current.indexOf('data:') === 0) img.src = src;
  }

  function whenScrubReady(img, done) {
    ensureScrubSrc(img);
    if (!img || (img.complete && img.naturalWidth > 1)) {
      done();
      return;
    }
    var finish = function () {
      img.removeEventListener('load', finish);
      img.removeEventListener('error', finish);
      done();
    };
    img.addEventListener('load', finish);
    img.addEventListener('error', finish);
  }

  function bumpScrubToken(root) {
    root._riScrubToken = (root._riScrubToken || 0) + 1;
    root._riScrubPending = null;
    return root._riScrubToken;
  }

  function go(root, index) {
    var imgs = root._riScrubImgs;
    var n = imgs.length;
    if (index < 0) index = 0;
    if (index >= n) index = n - 1;
    if (!root.closest('.ri-home-carousel')) {
      applyScrubIndex(root, index);
      return;
    }
    /* Already on this photo. Cancel a later photo that has not landed yet. */
    if (index === root._riScrubIndex) {
      if (root._riScrubPending != null) bumpScrubToken(root);
      return;
    }
    /* Homepage: keep the photo that is up until the next one has decoded. */
    if (root._riScrubPending === index) return;
    var token = bumpScrubToken(root);
    root._riScrubPending = index;
    whenScrubReady(imgs[index], function () {
      if (root._riScrubToken !== token) return;
      if (!imgs[index] || (imgs[index].naturalWidth || 0) <= 1) {
        root._riScrubPending = null;
        return;
      }
      applyScrubIndex(root, index);
    });
  }

  function pointInRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function hydrateScrub(root) {
    if (root._riScrubHydrated) return;
    root._riScrubHydrated = true;
    var imgs = root._riScrubImgs || [];
    for (var i = 0; i < imgs.length; i += 1) {
      var src = imgs[i].getAttribute('data-ri-scrub-src');
      if (!src) continue;
      var current = imgs[i].getAttribute('src') || '';
      if (!current || current.indexOf('data:') === 0) imgs[i].src = src;
    }
  }

  function bind(root) {
    if (root._riScrubBound) return;
    var media = root.querySelector('.ri-card-scrub__media');
    if (!media) return;
    var imgs = media.querySelectorAll('[data-ri-scrub-img]');
    if (imgs.length < 2) return;

    var card =
      root.closest('.ri-catalog-card') ||
      root.closest('.card-wrapper') ||
      root.closest('.card');
    if (!card) return;

    root._riScrubBound = true;
    root._riScrubImgs = imgs;
    root._riScrubSegs = root.querySelectorAll('.ri-card-scrub__seg');
    root._riScrubIndex = 0;

    var moveFrame = 0;
    var lastMove = null;
    card.addEventListener('mousemove', function (e) {
      lastMove = e;
      if (moveFrame) return;
      moveFrame = window.requestAnimationFrame(function () {
        moveFrame = 0;
        onMove(lastMove);
      });
    });

    function onMove(e) {
      if (!DESKTOP.matches) return;
      /* Don't scrub while a variant overlay is open */
      if (card.classList.contains('ri-choose-open')) return;

      var rect = media.getBoundingClientRect();
      if (!pointInRect(e.clientX, e.clientY, rect)) {
        if (root.classList.contains('is-hover-media')) {
          root.classList.remove('is-hover-media');
          go(root, 0);
        }
        return;
      }

      root.classList.add('is-hover-media');
      hydrateScrub(root);
      var n = imgs.length;
      var x = e.clientX - rect.left;
      var index = Math.floor((x / rect.width) * n);
      go(root, index);
    }

    card.addEventListener('mouseleave', function () {
      if (moveFrame) {
        window.cancelAnimationFrame(moveFrame);
        moveFrame = 0;
      }
      root.classList.remove('is-hover-media');
      if (root.closest('.ri-home-carousel')) {
        bumpScrubToken(root);
        applyScrubIndex(root, 0);
        return;
      }
      go(root, 0);
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.ri-catalog-card .card__media[data-ri-scrub]');
    for (var i = 0; i < roots.length; i += 1) bind(roots[i]);
  }

  function scheduleInit(scope) {
    if (reinitTimer) window.clearTimeout(reinitTimer);
    reinitTimer = window.setTimeout(function () {
      reinitTimer = null;
      init(scope || document);
    }, 80);
  }

  function isProductGridNode(node) {
    return (
      node &&
      node.nodeType === 1 &&
      (node.id === 'product-grid' ||
        (node.classList && node.classList.contains('product-grid')) ||
        (node.querySelector && node.querySelector('#product-grid.product-grid, #product-grid')))
    );
  }

  function observeGridHost() {
    var host =
      document.getElementById('ProductGridContainer') ||
      document.querySelector('.product-grid-container');
    if (!host || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (mutations) {
      var shouldReinit = mutations.some(function (m) {
        if (m.type !== 'childList') return false;

        var grid = document.getElementById('product-grid');
        if (grid && m.target === grid) {
          return m.addedNodes.length > 0 || m.removedNodes.length > 0;
        }

        for (var i = 0; i < m.addedNodes.length; i += 1) {
          if (isProductGridNode(m.addedNodes[i])) return true;
        }
        for (var j = 0; j < m.removedNodes.length; j += 1) {
          if (isProductGridNode(m.removedNodes[j])) return true;
        }
        /* Facet AJAX replaces ProductGridContainer.innerHTML wholesale */
        if (m.target === host && (m.addedNodes.length || m.removedNodes.length)) return true;
        return false;
      });

      if (!shouldReinit) return;
      scheduleInit(document.getElementById('product-grid') || document);
    }).observe(host, { childList: true, subtree: true });
  }

  function observeLateShelves() {
    if (typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('product-recommendations, .related-products, .ri-recently-viewed').forEach(function (host) {
      if (host._riScrubWatch) return;
      host._riScrubWatch = true;
      new MutationObserver(function () {
        scheduleInit(host);
      }).observe(host, { childList: true, subtree: true });
    });
  }

  function boot() {
    init();
    observeGridHost();
    observeLateShelves();
  }

  window.RICardScrub = { init: init, scheduleInit: scheduleInit };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scheduleInit(e.target);
    observeLateShelves();
  });
})();
